import { filter, forEach, get, includes, isNil, join, replace, some, split, startsWith } from 'lodash';

export const appendQueryParams = (url, params) => {
    let hasParams = false;
    forEach(params, function(value, key) {
        if (!isNil(value)) {
            if (!hasParams) {
                url += `?${key}=${value}`;
                hasParams = true;
            }
            else {
                url += `&${key}=${value}`;
            }
        }
    });
    return url;
};

export const retrieveErrorInternalCode = (error) => {
    return get(error, 'response.data.messages.errors[0].internal_code', null);
};

export function inferProfileUrl() {
    let hostname = window.location.host;
    hostname = replace(hostname, 'portal3.', 'profile.');
    hostname = replace(hostname, 'portal.', 'profile.');
    hostname = replace(hostname, 'portal-dot-', 'profile-dot-');
    hostname = replace(hostname, 'clients3.', 'profile.');
    hostname = replace(hostname, 'clients.', 'profile.');
    hostname = replace(hostname, 'public-dot-', 'profile-dot-');
    hostname = replace(hostname, 'admin3.', 'profile.');
    hostname = replace(hostname, 'admin.', 'profile.');
    hostname = replace(hostname, 'admin-dot-', 'profile-dot-');
    hostname = replace(hostname, '8082', '8084');
    hostname = replace(hostname, '8081', '8084');
    hostname = replace(hostname, '8080', '8084');
    return window.location.protocol + '//' + hostname;
}

export function inferCookieDomain(domain = null) {
    let hostname = domain || process.env.VUE_APP_COOKIE_DOMAIN || window.location.hostname;
    hostname = replace(hostname, 'admin3.', '');
    hostname = replace(hostname, 'admin.', '');
    hostname = replace(hostname, 'clients3.', '');
    hostname = replace(hostname, 'clients.', '');
    return hostname;
}

export function isAdminApp() {
    return includes(window.location.host, 'admin') || includes(window.location.host, 'localhost:8080');
}

export const expectedRtkpValue = (domain = window.location.hostname) => {
    return join(['profile', inferCookieDomain(domain)], '.');
};

export const hasRtkpCookie = (domain = window.location.hostname, cookies = document.cookie) => {
    const rtkps = filter(split(cookies, '; '), cookie => startsWith(cookie, 'rtkp='));
    return some(rtkps, rtkp => {
        const rtkpValue = split(rtkp, '=')[1];
        return rtkpValue === expectedRtkpValue(domain);
    });
};

export const isUsingKc = !!(typeof process !== 'undefined' && process.env.VUE_APP_IS_USING_KEYCLOAK_LOGIN_AUTH === 'true');

/**
 * Detect availability of the localstorage which is not guarantee in context like the private browser.
 * Ref: https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API
 * @param {*} type
 * @returns
 */
export function localStorageAvailable() {
    let storage;
    try {
        storage = window['localStorage'];
        const x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);

        return true;
    }
    catch (e) {
        return (
            e instanceof DOMException &&
        // everything except Firefox
        (e.code === 22 ||
          // Firefox
          e.code === 1014 ||
          // test name field too, because code might not be present
          // everything except Firefox
          e.name === 'QuotaExceededError' ||
          // Firefox
          e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
        // acknowledge QuotaExceededError only if there's something already stored
        storage &&
        storage.length !== 0
        );
    }
}
